// The filters. Each one applies the moment it is touched; there is no
// "apply" step to discover. On phones the rail folds into a Filters button.
import { useState } from "react";
import type { TypeCount } from "@/hooks/useJobBoardStats";

export type Toggles = { remote: boolean; internship: boolean; contract: boolean; parttime: boolean };

type Props = {
  types?: TypeCount[];
  category: string;
  onCategory: (label: string) => void;
  toggles: Toggles;
  onToggle: (key: keyof Toggles) => void;
  remoteCount?: number;
};

const TYPE_ROWS: [keyof Toggles, string][] = [
  ["remote", "Remote"],
  ["internship", "Internship"],
  ["contract", "Contract"],
  ["parttime", "Part-time"],
];

export default function BoardRail({ types, category, onCategory, toggles, onToggle, remoteCount }: Props) {
  const [open, setOpen] = useState(false);
  const active = (category ? 1 : 0) + Object.values(toggles).filter(Boolean).length;

  return (
    <aside className={`bh-rail${open ? " is-open" : ""}`} aria-label="Filter jobs">
      <button type="button" className="bh-rail__toggle" aria-expanded={open} onClick={() => setOpen((v) => !v)}>
        <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth={2.2} strokeLinecap="round" aria-hidden="true"><path d="M4 6h16M7 12h10M10 18h4" /></svg>
        Filters{active ? ` · ${active}` : ""}
      </button>
      <div className="bh-rail__body">
        <fieldset className="bh-rail__group">
          <legend>Role</legend>
          <label className="bh-rail__opt">
            <input type="radio" name="bh-role" checked={!category} onChange={() => onCategory("")} />
            <span>All roles</span>
          </label>
          {(types ?? []).slice(0, 6).map((t) => (
            <label key={t.key} className="bh-rail__opt">
              <input type="radio" name="bh-role" checked={category === t.label} onChange={() => onCategory(t.label)} />
              <span>{t.label}</span>
              <span className="bh-rail__n">{t.count.toLocaleString("en-US")}</span>
            </label>
          ))}
        </fieldset>
        <fieldset className="bh-rail__group">
          <legend>Work type</legend>
          {TYPE_ROWS.map(([key, label]) => (
            <label key={key} className="bh-rail__opt">
              <input type="checkbox" checked={toggles[key]} onChange={() => onToggle(key)} />
              <span>{label}</span>
              {key === "remote" && remoteCount ? <span className="bh-rail__n">{remoteCount.toLocaleString("en-US")}</span> : null}
            </label>
          ))}
        </fieldset>
        <p className="bh-rail__note">
          Every listing comes from the employer&rsquo;s own career page and is checked hourly. Closed roles drop off the board.
        </p>
      </div>
    </aside>
  );
}
